import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonSave: React.FC<MprcButtonProps> = ({ text, title, color = "success", variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonSave.text;
    const lTitle = title || theme.buttons.ButtonSave.title;

    return (
        <MprcButton
            {...rest}
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
            startIcon={variant == "text" && <FontAwesomeIcon icon={faCheck} />}
        />
    );
};
